module.exports = __webpack_public_path__ + "cfb804faa999688fb776e3d2e0433c3e.png";